import CryptoJS from 'crypto-js'

const AES_PASSPHRASE = import.meta.env.VITE_PLEXTIME_AES_PASSPHRASE || ''

/**
 * Encrypt login credentials using CryptoJS AES (EVP_BytesToKey + AES-256-CBC).
 * Matches PlexTime PRO frontend format:
 * CryptoJS.AES.encrypt(JSON.stringify(JSON.stringify(data)), secret)
 */
export function encryptCredentials(email: string, password: string): string {
    const payload = { email, password }
    const plaintext = JSON.stringify(JSON.stringify(payload))
    return CryptoJS.AES.encrypt(plaintext, AES_PASSPHRASE).toString()
}
